import { listStoreBuilder } from '@/main/store/pages/list/builder';
import { TABLE_DATA } from '@/main/store/listEditTypes';
import { updateTableDataAction } from '@/main/store/actionsFunctions';

import { NAME as name, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';
import { types } from './types';

export const store = listStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {},
	filter: {
		PracovnikId: null as number | null,
		PracovnikIdText: null as string | null,
		PracovnikOsobniCis: null as string | null,
		VstupDatDo: null as string | null,
		VstupDatOd: null as string | null,
		McostEnum: [],
		McotEnum: [],
		McotKategEnum: [],
	},
	tableSetting: {},
	localState: {},
	rowDetail: null,
	extraActions: {
		[TABLE_DATA]: ({ state, commit, dispatch }, filter) => updateTableDataAction(
			state,
			commit,
			dispatch,
			apiProvider.getTableData({ ...filter }),
			'table',
		),
	},
	extraGetters: {},
	extraMutations: {
		[types.mutations.PRACOVNIK_SELECT_MAPPER](state, { data }) {
			state.filter.PracovnikId = data.value;
			state.filter.PracovnikIdText = data.jmeno || data.text ? `${data.text} ${data.jmeno}` : null;
			state.filter.PracovnikOsobniCis = data.osobniCis;
		},
	},
	props: {
		mode: null,
		filter: {},
		afterRowSelection: () => {},
	},
});
